export function getFormattedDateTime(date: Date | string): string {
    return new Date(date).toLocaleTimeString('en-us', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
    });
}
